import axios from "axios";
import { API_BASE_URL } from "../../../config";

export async function fetchAdminUserTransactions(
  userId,
  { page = 1, limit = 20, type = "all", status = "all" } = {}
) {
  const token = localStorage.getItem("adminToken");
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    type,
    status,
  });

  const { data } = await axios.get(
    `${API_BASE_URL}/api/website/users/${userId}/transactions?${params.toString()}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return data;
}
